import { Observable } from 'rxjs';
import { take, shareReplay } from 'rxjs/operators';
import { Injectable, Inject, Component, Input, ElementRef, Output, EventEmitter, NgModule, defineInjectable, inject } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScriptService = /** @class */ (function () {
    function ScriptService(_document) {
        this._document = _document;
        this.scriptsLoaders = {};
    }
    /**
     *
     * @param url Url of the external script to be loaded
     * @param attributes Attribute list to be added to the script element
     * @param targetEl Target element for the placing script tag. It can be a selector or a element reference
     */
    /**
     *
     * @param {?} url Url of the external script to be loaded
     * @param {?=} attributes Attribute list to be added to the script element
     * @param {?=} targetEl Target element for the placing script tag. It can be a selector or a element reference
     * @return {?}
     */
    ScriptService.prototype.loadScript = /**
     *
     * @param {?} url Url of the external script to be loaded
     * @param {?=} attributes Attribute list to be added to the script element
     * @param {?=} targetEl Target element for the placing script tag. It can be a selector or a element reference
     * @return {?}
     */
    function (url, attributes, targetEl) {
        var _this = this;
        if (targetEl === void 0) { targetEl = 'head'; }
        return this.scriptsLoaders[url] = this.scriptsLoaders[url] || new Observable(function (observer) {
            /** @type {?} */
            var script = _this._document.createElement('script');
            if (attributes) {
                for (var key in attributes) {
                    if (attributes.hasOwnProperty(key)) {
                        script.setAttribute(key, attributes[key]);
                    }
                }
            }
            script.onload = function (event) {
                observer.next(event);
                observer.complete();
            };
            script.onerror = function (err) {
                observer.error(err);
            };
            script.src = url;
            /** @type {?} */
            var targetElement = typeof targetEl === 'string' ? _this._document.querySelector(targetEl) : targetEl;
            targetElement.appendChild(script);
        })
            .pipe(take(1), shareReplay(1));
    };
    ScriptService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ScriptService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    /** @nocollapse */ ScriptService.ngInjectableDef = defineInjectable({ factory: function ScriptService_Factory() { return new ScriptService(inject(DOCUMENT)); }, token: ScriptService, providedIn: "root" });
    return ScriptService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScriptComponent = /** @class */ (function () {
    function ScriptComponent(scriptService, element) {
        this.scriptService = scriptService;
        this.element = element;
        this.attributes = {};
        this.load = new EventEmitter();
        this.error = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ScriptComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.scriptService.loadScript(this.src, this.attributes, this.element.nativeElement)
            .subscribe(function (event) {
            _this.load.emit(event);
        }, function (error) {
            _this.error.emit(error);
        });
    };
    ScriptComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-script',
                    template: ''
                }] }
    ];
    /** @nocollapse */
    ScriptComponent.ctorParameters = function () { return [
        { type: ScriptService },
        { type: ElementRef }
    ]; };
    ScriptComponent.propDecorators = {
        src: [{ type: Input }],
        attributes: [{ type: Input }],
        load: [{ type: Output }],
        error: [{ type: Output }]
    };
    return ScriptComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScriptLoaderModule = /** @class */ (function () {
    function ScriptLoaderModule() {
    }
    ScriptLoaderModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ScriptComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        ScriptComponent
                    ]
                },] }
    ];
    return ScriptLoaderModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ScriptService, ScriptComponent, ScriptLoaderModule };

//# sourceMappingURL=ngx-script-loader.js.map